export enum FiltersToolbarActionsTypes {
  FILTERS_CHANGED = 'FILTERS_CHANGED',
  FILTERS_CLEARED = 'FILTERS_CLEARED',
}
